import { render, staticRenderFns } from "./InputMask.vue?vue&type=template&id=fb022a38&"
import script from "./InputMask.vue?vue&type=script&lang=js&"
export * from "./InputMask.vue?vue&type=script&lang=js&"
import style0 from "./InputMask.vue?vue&type=style&index=0&id=fb022a38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports